import { ajvResolver } from '@hookform/resolvers/ajv'
import { Form } from 'components/form'
import { useAlert } from 'contexts/alert'
import { ICountryDTO } from 'data/dtos/common/i-country-dto'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useParams } from 'react-router-dom'
import CountrySchema, { ICountryFormData } from 'schema/common/country'
import api from 'services/api'
import { useStyles } from './styles'

interface IRouteParams {
  id: string
}

const CountryForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [readonly, setReadonly] = useState(false)
  const { closeAlert, openAlert } = useAlert()
  const params = useParams<IRouteParams>()
  const firstInputElement = useRef(null)
  const classes = useStyles()
  const history = useHistory()

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
    setFocus,
  } = useForm<ICountryFormData>({
    resolver: ajvResolver(CountrySchema),
    defaultValues: {
      name: '',
    },
  })

  const handleChange = (formField: any) => closeAlert()

  // main data load
  useEffect(() => {
    async function loadData() {
      const { id } = params

      // form data
      await api
        .get(`/countries/${id}`)
        .then((response) => {
          const { data } = response.data

          const countryResult = {
            name: data.name,
          }

          return countryResult
        })
        .then((countryResult: ICountryDTO) => {
          reset(countryResult)
        })
        .catch((error) => {
          console.log(error)
          return error
        })
    }

    if (params.id) {
      loadData()
      setReadonly(true)
    }
  }, [params, params.id])

  // data save

  const onSubmit = useCallback(async (data: ICountryDTO) => {
    setIsLoading(true)

    const payLoad: ICountryDTO = {
      name: data.name,
    }

    if (params.id) {
      const { id } = params

      payLoad.id = id

      await api
        .put(`/countries`, payLoad)
        .then(() => {
          openAlert('Cliente atualizado com sucesso!', 'success')
          history.push('/countries')
        })
        .catch((error) => {
          openAlert(error?.response?.data?.data?.message ?? 'Ops! Algo inesperado aconteceu!', 'error')
        })
        .finally(() => setIsLoading(false))
    } else {
      await api
        .post('/countries', payLoad)
        .then(() => {
          openAlert('Dado cadastrado com sucesso!', 'success')
          reset()
        })
        .catch((error) => {
          openAlert(error?.response?.data?.data?.message ?? 'Ops! Algo inesperado aconteceu!', 'error')
        })
        .finally(() => setIsLoading(false))
    }
  }, [])

  useEffect(() => {
    // setFocus(firstInputElement)
  }, [setFocus])

  return (
    <Form.Root onHandleSubmit={handleSubmit(onSubmit)}>
      <Form.Info
        title='Países'
        subTitle='Aqui são informados dados sobre países.'
      />
      <Form.Body>
        <Form.Input
          label='Nome'
          error={!!errors.name}
          errorMessage={errors?.name?.message}
          disabled={isLoading || readonly}
          sizing={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          maxLength={100}
          name='name'
          rules={{ onChange: (e) => handleChange(e) }}
          register={register}
        />
      </Form.Body>

      <Form.Divisor />

      <Form.Footer>
        <Form.Button
          label='SALVAR'
          type='submit'
          variant='contained'
          isLoading={isLoading}
        />
        <Form.Button
          label='CANCELAR'
          type='cancel'
          variant='text'
          isLoading={isLoading}
        />
      </Form.Footer>
    </Form.Root>
  )
}

export default CountryForm
